// 隐藏历史记录
export class History {
  hideList: number[][]
  showList: number[][]

  constructor() {
    this.hideList = []
    this.showList = []
  }

  record(_hide: number[] = [], _show: number[] = []): void {
    const hide = Array.isArray(_hide) ? _hide : [_hide]
    const show = Array.isArray(_show) ? _show : [_show]
    // 获得当前的隐藏列表
    const hideList = this.getHideList()
    const showList = this.getShowList()
    // 将当前的隐藏列表和新的隐藏列表合并，删除重复的
    const newHideList = [...hideList, ...hide]
    const newShowList = [...showList, ...show]
    // 将新的隐藏列表加入历史记录
    this.hideList.push(newHideList)
    this.showList.push(newShowList)
  }

  undo(): void {
    if (this.hideList.length > 0) {
      this.hideList.pop()
    }
    if (this.showList.length > 0) {
      this.showList.pop()
    }
  }

  getHideList(): number[] {
    return this.hideList[this.hideList.length - 1] ?? []
  }

  getShowList(): number[] {
    return this.showList[this.showList.length - 1] ?? []
  }

  hideListHas(position_id: number) {
    return this.getHideList().includes(position_id)
  }

  showListHas(position_id: number) {
    return this.getShowList().includes(position_id)
  }
}
